// @flow

import "./index.css";
import type { Beacon } from "../Live/App";

import React from "react";

import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";

type Props = {
  beacons: Array<Beacon>,
  waitingForAd: boolean,
  showCount: boolean,
  classes: any
};

const displayBeacons = [
  "start",
  "impression",
  "firstQuartile",
  "midpoint",
  "thirdQuartile",
  "complete"
];

type BeaconInfo = {
  sentCount: number,
  totalCount: number
};

type BeaconInfoMap = Map<string, BeaconInfo>;

const reduceBeaconsToInfo = (beacons: Array<Beacon>): BeaconInfoMap => {
  const callback = (acc: BeaconInfoMap, beacon: Beacon): BeaconInfoMap => {
    let info = acc.get(beacon.kind) || { sentCount: 0, totalCount: 0 };

    info.totalCount++;
    if (beacon.sent) {
      info.sentCount++;
    }

    return acc.set(beacon.kind, info);
  };

  return beacons.reduce(callback, new Map([]));
};

const Beaconing = (props: Props) => {
  const humanLabels = {
    start: "Start",
    impression: "Impression",
    firstQuartile: "25% Complete",
    midpoint: "50% Complete",
    thirdQuartile: "75% Complete",
    complete: "Completed"
  };

  const beaconInfos = reduceBeaconsToInfo(props.beacons);

  const waitingForAdIndicator = () => {
    if (props.waitingForAd) {
      return <Typography>Waiting for ad break</Typography>;
    }
    return null;
  };

  const showCount = (count: number) => {
    if (count <= 1) {
      return "";
    }

    return "(" + count.toString() + ")";
  };

  const beaconsStepper = () => {
    if (props.waitingForAd) {
      //return null;
    }

    return (
      <Stepper
        alternativeLabel
        nonLinear
        activeStep={-1}
        classes={{ root: props.classes.stepperRoot }}
      >
        {displayBeacons.map((kind: string) => {
          const info = beaconInfos.get(kind);
          if (!info) {
            return null;
          }

          return (
            <Step key={kind}>
              <StepLabel completed={info.sentCount > 0}>
                {humanLabels[kind]}{" "}
                {props.showCount ? showCount(info.totalCount) : null}
              </StepLabel>
            </Step>
          );
        })}
      </Stepper>
    );
  };

  return (
    <Card>
      <CardHeader title="Beacons" />
      <CardContent>
        {beaconsStepper()}
        {waitingForAdIndicator()}
      </CardContent>
    </Card>
  );
};

const styles = theme => ({
  stepperRoot: {
    padding: "0"
  }
});

export default withStyles(styles)(Beaconing);



// WEBPACK FOOTER //
// ./src/Beaconing/index.js